import React from 'react';
const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-spinner"></div>
      <div className="loader-text">Please wait...</div>
    </div>
  );
};

export default Loader;
